
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
			//ajax地址
			getVipInfo: `/apis/moyin-account/v1/vip/status`,
			// 检查token状态
			getAsyncResult: `get /apis/moyin-tool/v1/subtitles/asyncResult`,
			postExtract: `post /apis/moyin-tool/v1/subtitles/asyncExtract`,
			
			// 兼容wechat-token
			deleteAsyncExtract: {
				custom: true,
				url: (data:any)=>`/apis/moyin-tool/v1/subtitles/asyncExtract/${data.taskId}`,
				method: 'delete'
			},
			uploadFileV2: {
				custom: true,
				url: () => `/apis/moyin-tool/v1/subtitles/uploadFileV2`,
				method: 'post',
				headers: {
					'content-type': 'multipart/form-data'
				}
			},
			postAchieveSubtitleVideoInfo: `post /apis/moyin-tool/v1/videoToAudio/achieveSubtitleVideoInfo`,
			getFunctionList: {
				custom: true,
				url: (data:any)=>`/apis/tts-web-api/v1/app/functionSwitchConfig/allFunctionSwitch?`,
				method: 'get'
			}
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"fileExtractPage"
			})
		}